import LogoutIcon from "@mui/icons-material/Logout";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ErrorDialog from "../../components/dialogs/ErrorDialog.js";
import { useUser } from "../../components/UserContext.js";
import {
  PAGE_CONTAINER_SX,
  RING_SIZE,
  ROUTES,
  SESSION_STORAGE_USER_KEY,
} from "../../lib/constants.js";
import AlephLogo from "./components/AlephLogo.js";
import UploadPhoto from "./components/UploadPhoto.js";

export default function Home({ locales }) {
  const { setUser, runId } = useUser();
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  return (
    <Container
      disableGutters
      sx={{
        ...PAGE_CONTAINER_SX,
        alignItems: "center",
      }}
    >
      <Typography component="h1" variant="body1">
        {locales["home.welcome"]}
      </Typography>
      <AlephLogo locales={locales} />
      <Box display="flex" justifyContent="space-around" width={RING_SIZE}>
        <UploadPhoto locales={locales} />
        <IconButton
          aria-label={locales["home.logout.button"]}
          color="secondary"
          onClick={() => {
            setUser({});
            sessionStorage.removeItem(SESSION_STORAGE_USER_KEY);
            navigate(ROUTES.BASE.replace(":runId", runId), { replace: true });
          }}
          size="large"
        >
          <LogoutIcon />
        </IconButton>
      </Box>
      <ErrorDialog
        locales={locales}
        message={errorMessage}
        onClose={() => {
          setShowError(false);
          setErrorMessage(null);
        }}
        show={showError}
      />
    </Container>
  );
}
